import aggregate from "./aggregate.js";
import processResults from "./processResults.js";
import pointAllocation from "./pointAllocation.js";
import assignPositions from "./assignPositions.js";
import shell from "./shell.js";
import sortPlayers from "./sortPlayers.js";
import numberToOrdinal from "./numberToOrdinal.js";

export {
	aggregate,
	processResults,
	pointAllocation,
	assignPositions,
	shell,
	sortPlayers,
	numberToOrdinal,
};

export default {
	aggregate,
	processResults,
	pointAllocation,
	assignPositions,
	shell,
	sortPlayers,
	numberToOrdinal,
};
